export type TitleKind = "receivable" | "payable";
export type TitleStatus = "open" | "paid" | "canceled";
export type AccountKind = "bank" | "cash" | "acquirer" | "wallet";
export type DreGroup = "rob" | "ded" | "cat" | "pes" | "adm" | "fin" | "luc" | "loan" | "capex";
export type EntryOrigin = "manual" | "receivable" | "payable" | "cashbox" | "sale";

export const PAYMENT_METHODS = [
  "pix",
  "cash",
  "debit_card",
  "credit_card",
  "boleto",
  "transfer",
  "auto_debit",
  "tax_slip",
  "insurance",
] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const DRE_GROUPS: DreGroup[] = ["rob", "ded", "cat", "pes", "adm", "fin", "luc"];

export interface FinancialAccount {
  id: string;
  clinic_id: string;
  kind: AccountKind;
  system_key: string | null;
  name: string;
  opening_balance: number;
  is_active: boolean;
}

export interface FinancialCategory {
  id: string;
  clinic_id: string;
  dre_group: DreGroup;
  direction: "in" | "out";
  system_key: string | null;
  name: string;
  sort_order: number;
  is_active: boolean;
}

export interface FinancialTitle {
  id: string;
  clinic_id: string;
  kind: TitleKind;
  counterparty_name: string;
  counterparty_detail: string | null;
  description: string;
  category_id: string | null;
  payment_method: PaymentMethod;
  due_date: string;
  competence_date: string;
  amount: number;
  status: TitleStatus;
  paid_at: string | null;
  installment_number: number | null;
  installment_count: number | null;
  created_at: string;
  sale_id?: string | null;
  sale_payment_id?: string | null;
}

export interface FinancialEntry {
  id: string;
  clinic_id: string;
  account_id: string;
  category_id: string | null;
  amount: number;
  description: string;
  detail: string | null;
  payment_method: PaymentMethod | null;
  occurred_at: string;
  competence_date: string;
  origin: EntryOrigin;
  title_id: string | null;
  cash_session_id: string | null;
  voided_at: string | null;
  sale_id?: string | null;
  sale_payment_id?: string | null;
}

export interface FinancialCashSession {
  id: string;
  clinic_id: string;
  business_date: string;
  opening_amount: number;
  opened_at: string;
  /** Quem abriu: pode fechar o próprio caixa mesmo sem permissão de editar o caixa. */
  opened_by?: string | null;
  opened_by_name: string | null;
  closed_at: string | null;
  closed_by_name: string | null;
}

export interface Period {
  from: string;
  to: string;
}
